
export default class AppState {
    constructor() {
        this.states = [];
    }

    setState(state, params) {
        if (state.name === "not_found_404" || state.name === "") {
            return
        }
        this.clearStack();
        this.states.push({state, params})
    }

    clearStack() {
        if (this.states.length === 5) {
            this.states.shift();
        }
    }

    getState() {
        if (this.states.length) {
            let states = angular.copy(this.states);
            return states.pop();
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./modules/distribution/services/app_state.js